import React, { Component } from "react";
import postError from "../../api/postError";

import { LinkContainer } from "react-router-bootstrap";

import * as routes from "routes";
import Button from "react-bootstrap/cjs/Button";
import Alert from "react-bootstrap/cjs/Alert";
import Spinner from "react-bootstrap/cjs/Spinner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      reporting: false,
      reported: false,
      reportSuccessful: false,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
    };
  }

  async componentDidCatch(error, errorInfo) {
    const { name } = error;
    if (name === "ChunkLoadError") {
      window.location.reload();
    } else {
      this.setState({
        reporting: true,
      });
      try {
        await postError({ error, errorInfo });
        this.setState({
          reportSuccessful: true,
        });
      } finally {
        this.setState({
          reporting: false,
          reported: true,
        });
      }
    }
  }

  render() {
    const { hasError, reporting, reported, reportSuccessful } = this.state;
    if (hasError) {
      return (
        <Alert variant={"danger"}>
          <Alert.Heading>Sorry, there has been an error</Alert.Heading>
          {reporting && (
            <div>
              <Spinner variant={"light"} className={"mr-2"} />
              Sending report...
            </div>
          )}
          {!reporting && reportSuccessful && (
            <p>Our developers have been informed and will investigate the problem.</p>
          )}
          {!reporting && reported && (
            <LinkContainer to={routes.DASHBOARD}>
              <Button variant={"primary"}>Return to Dashboard</Button>
            </LinkContainer>
          )}
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
